import { ApiBase } from "@/runtime/ApiService";

/**
 * Get session ID from URL path. Falls back to 'default' on the root path
 * to mirror server-side default (server.ts).
 */
function getSessionFromUrl(): string {
  const path = window.location.pathname;
  return path.split('/')[1] || 'default';
}

export class ApiBaseWeb extends ApiBase {

  constructor() {

    super(getSessionFromUrl())
  }

;


}